import socketClusterClient from 'socketcluster-client'

let options = {
  hostname: process.env.VUE_APP_SOCKET_BASE_URL,
  secure: process.env.VUE_APP_SOCKET_SECURE,
  port: process.env.VUE_APP_SOCKET_PORT,
  rejectUnauthorized: process.env.VUE_APP_SOCKET_REJECT_UNAUTHORIZED,
  connectTimeout: 999999,
  pingTimeout: 9999999,
  ackTimeout: 9999999
}

const socketConnection = socketClusterClient.create(options)

export default socketConnection
